module.exports = __webpack_public_path__ + "img/jingzhuang11.4e43ed2b.jpg";